import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import './registerServiceWorker';

import { IonicVue } from '@ionic/vue';

import { store } from "./store";

import axios from 'axios';
import { Preferences } from '@capacitor/preferences';

// An expired/invalid token used to make every sync fail silently. Now it
// drops the stale token and sends the user back to the login screen.
axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        const requestUrl = error && error.config && error.config.url ? String(error.config.url) : '';

        if (error && error.response && error.response.status === 401 && requestUrl.indexOf('login') === -1) {
            await Preferences.remove({ key: 'access_token' });

            if (router.currentRoute.value.name !== 'Login') {
                router.push({ name: 'Login' });
            }
        }

        return Promise.reject(error);
    }
);

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './theme/pages.css';

import { defineCustomElements as jeepSqlite } from "jeep-sqlite/loader";

jeepSqlite(window);

// Not shown in the UI — check the browser console to identify a device's build.
console.info('LMP Scoring build:', process.env.VUE_APP_BUILD || 'dev');

const app = createApp(App)
  .use(IonicVue)
  .use(router)
  .use(store);

router.isReady().then(() => {
  app.mount('#app');
});